export const spritePath = {
    svgSprite: '/img/sprite.svg',
    countriesSprite:'/img/countriesSprite.svg',
}

export const Icons = {
    eyeSlash: {
        id:"i_eyeSlash",
        spritePath: spritePath.svgSprite,
    },
    eye: {
        id:"i_eye",
        spritePath: spritePath.svgSprite,
    },
    warningCircle: {
        id:"i_warningCircle",
        spritePath: spritePath.svgSprite,
    },
    check: {
        id:"i_check",
        spritePath: spritePath.svgSprite,
    },
    caretDown: {
        id:"i_caretDown",
        spritePath: spritePath.svgSprite,
    },
    caretUp: {
        id:"i_caretUp",
        spritePath: spritePath.svgSprite,
    },
    magnifyingGlass: {
        id:"i_magnifyingGlass",
        spritePath: spritePath.svgSprite,
    },
    Afghanistan: {
        id: "i_Afghanistan",
        spritePath: spritePath.countriesSprite,
    },
    Albania: {
        id: "i_Albania",
        spritePath: spritePath.countriesSprite,
    },
    Algeria: {
        id: "i_Algeria",
        spritePath: spritePath.countriesSprite,
    },
    Andorra: {
        id: "i_Andorra",
        spritePath: spritePath.countriesSprite,
    },
    Angola: {
        id: "i_Angola",
        spritePath: spritePath.countriesSprite,
    },
    Antigua_and_Barbuda: {
        id: "i_Antigua_and_Barbuda",
        spritePath: spritePath.countriesSprite,
    },
    Argentina: {
        id: "i_Argentina",
        spritePath: spritePath.countriesSprite,
    },
    Armenia: {
        id: "i_Armenia",
        spritePath: spritePath.countriesSprite,
    },
    Aruba: {
        id: "i_Aruba",
        spritePath: spritePath.countriesSprite,
    },
    Australia: {
        id: "i_Australia",
        spritePath: spritePath.countriesSprite,
    },
    Austria: {
        id: "i_Austria",
        spritePath: spritePath.countriesSprite,
    },
    Azerbaijan: {
        id: "i_Azerbaijan",
        spritePath: spritePath.countriesSprite,
    },
    Bahamas: {
        id: "i_Bahamas",
        spritePath: spritePath.countriesSprite,
    },
    Bahrain: {
        id: "i_Bahrain",
        spritePath: spritePath.countriesSprite,
    },
    Bangladesh: {
        id: "i_Bangladesh",
        spritePath: spritePath.countriesSprite,
    },
    Barbados: {
        id: "i_Barbados",
        spritePath: spritePath.countriesSprite,
    },
    Belarus: {
        id: "i_Belarus",
        spritePath: spritePath.countriesSprite,
    },
    Belgium: {
        id: "i_Belgium",
        spritePath: spritePath.countriesSprite,
    },
    Belize: {
        id: "i_Belize",
        spritePath: spritePath.countriesSprite,
    },
    Benin: {
        id: "i_Benin",
        spritePath: spritePath.countriesSprite,
    },
    Bhutan: {
        id: "i_Bhutan",
        spritePath: spritePath.countriesSprite,
    },
    Bolivia: {
        id: "i_Bolivia",
        spritePath: spritePath.countriesSprite,
    },
    BosniaAndHerzegovina: {
        id: "i_Bosnia_and_Herzegovina",
        spritePath: spritePath.countriesSprite,
    },
    Botswana: {
        id: "i_Botswana",
        spritePath: spritePath.countriesSprite,
    },
    Brazil: {
        id: "i_Brazil",
        spritePath: spritePath.countriesSprite,
    },
    BritishIndianOceanTerritory: {
        id: "i_British_Indian_Ocean_Territory",
        spritePath: spritePath.countriesSprite,
    },
    Brunei: {
        id: "i_Brunei",
        spritePath: spritePath.countriesSprite,
    },
    Bulgaria: {
        id: "i_Bulgaria",
        spritePath: spritePath.countriesSprite,
    },
    BurkinaFaso: {
        id: "i_Burkina_Faso",
        spritePath: spritePath.countriesSprite,
    },
    Burundi: {
        id: "i_Burundi",
        spritePath: spritePath.countriesSprite,
    },
    Cambodia: {
        id: "i_Cambodia",
        spritePath: spritePath.countriesSprite,
    },
    Cameroon: {
        id: "i_Cameroon",
        spritePath: spritePath.countriesSprite,
    },
    Canada: {
        id: "i_Canada",
        spritePath: spritePath.countriesSprite,
    },
    CapeVerde: {
        id: "i_Cape_Verde",
        spritePath: spritePath.countriesSprite,
    },
    CaribbeanNetherlands: {
        id: "i_Caribbean_Netherlands",
        spritePath: spritePath.countriesSprite,
    },
    CaymanIslands: {
        id: "i_Cayman_Islands",
        spritePath: spritePath.countriesSprite,
    },
    CentralAfricanRepublic: {
        id: "i_Central_African_Republic",
        spritePath: spritePath.countriesSprite,
    },
    Chad: {
        id: "i_Chad",
        spritePath: spritePath.countriesSprite,
    },
    Chile: {
        id: "i_Chile",
        spritePath: spritePath.countriesSprite,
    },
    China: {
        id: "i_China",
        spritePath: spritePath.countriesSprite,
    },
    Colombia: {
        id: "i_Colombia",
        spritePath: spritePath.countriesSprite,
    },
    Comoros: {
        id: "i_Comoros",
        spritePath: spritePath.countriesSprite,
    },
    CongoCD: {
        id: "i_Congo",
        spritePath: spritePath.countriesSprite,
    },
    CostaRica: {
        id: "i_Costa_Rica",
        spritePath: spritePath.countriesSprite,
    },
    CôteDIvoire: {
        id: "i_Côte_d'Ivoire",
        spritePath: spritePath.countriesSprite,
    },
    Croatia: {
        id: "i_Croatia",
        spritePath: spritePath.countriesSprite,
    },
    Cuba: {
        id: "i_Cuba",
        spritePath: spritePath.countriesSprite,
    },
    Curaçao: {
        id: "i_Curaçao",
        spritePath: spritePath.countriesSprite,
    },
    Cyprus: {
        id: "i_Cyprus",
        spritePath: spritePath.countriesSprite,
    },
    CzechRepublic: {
        id: "i_Czech_Republic",
        spritePath: spritePath.countriesSprite,
    },
    Denmark: {
        id: "i_Denmark",
        spritePath: spritePath.countriesSprite,
    },
    Djibouti: {
        id: "i_Djibouti",
        spritePath: spritePath.countriesSprite,
    },
    Dominica: {
        id: "i_Dominica",
        spritePath: spritePath.countriesSprite,
    },
    DominicanRepublic: {
        id: "i_Dominican_Republic",
        spritePath: spritePath.countriesSprite,
    },
    Ecuador: {
        id: "i_Ecuador",
        spritePath: spritePath.countriesSprite,
    },
    Egypt: {
        id: "i_Egypt",
        spritePath: spritePath.countriesSprite,
    },
    ElSalvador: {
        id: "i_El_Salvador",
        spritePath: spritePath.countriesSprite,
    },
    EquatorialGuinea: {
        id: "i_Equatorial_Guinea",
        spritePath: spritePath.countriesSprite,
    },
    Eritrea: {
        id: "i_Eritrea",
        spritePath: spritePath.countriesSprite,
    },
    Estonia: {
        id: "i_Estonia",
        spritePath: spritePath.countriesSprite,
    },
    Ethiopia: {
        id: "i_Ethiopia",
        spritePath: spritePath.countriesSprite,
    },
    Fiji: {
        id: "i_Fiji",
        spritePath: spritePath.countriesSprite,
    },
    Finland: {
        id: "i_Finland",
        spritePath: spritePath.countriesSprite,
    },
    France: {
        id: "i_France",
        spritePath: spritePath.countriesSprite,
    },
    FrenchGuiana: {
        id: "i_French_Guiana",
        spritePath: spritePath.countriesSprite,
    },
    FrenchPolynesia: {
        id: "i_French_Polynesia",
        spritePath: spritePath.countriesSprite,
    },
    Gabon: {
        id: "i_Gabon",
        spritePath: spritePath.countriesSprite,
    },
    Gambia: {
        id: "i_Gambia",
        spritePath: spritePath.countriesSprite,
    },
    Georgia: {
        id: "i_Georgia",
        spritePath: spritePath.countriesSprite,
    },
    Germany: {
        id: "i_Germany",
        spritePath: spritePath.countriesSprite,
    },
    Ghana: {
        id: "i_Ghana",
        spritePath: spritePath.countriesSprite,
    },
    Greece: {
        id: "i_Greece",
        spritePath: spritePath.countriesSprite,
    },
    Greenland: {
        id: "i_Greenland",
        spritePath: spritePath.countriesSprite,
    },
    Grenada: {
        id: "i_Grenada",
        spritePath: spritePath.countriesSprite,
    },
    Guadeloupe: {
        id: "i_Guadeloupe",
        spritePath: spritePath.countriesSprite,
    },
    Guam: {
        id: "i_Guam",
        spritePath: spritePath.countriesSprite,
    },
    Guatemala: {
        id: "i_Guatemala",
        spritePath: spritePath.countriesSprite,
    },
    Guinea: {
        id: "i_Guinea",
        spritePath: spritePath.countriesSprite,
    },
    Guinea_Bissau: {
        id: "i_Guinea-Bissau",
        spritePath: spritePath.countriesSprite,
    },
    Guyana: {
        id: "i_Guyana",
        spritePath: spritePath.countriesSprite,
    },
    Haiti: {
        id: "i_Haiti",
        spritePath: spritePath.countriesSprite,
    },
    Honduras: {
        id: "i_Honduras",
        spritePath: spritePath.countriesSprite,
    },
    HongKong: {
        id: "i_Hong_Kong",
        spritePath: spritePath.countriesSprite,
    },
    Hungary: {
        id: "i_Hungary",
        spritePath: spritePath.countriesSprite,
    },
    Iceland: {
        id: "i_Iceland",
        spritePath: spritePath.countriesSprite,
    },
    India: {
        id: "i_India",
        spritePath: spritePath.countriesSprite,
    },
    Indonesia: {
        id: "i_Indonesia",
        spritePath: spritePath.countriesSprite,
    },
    Iran: {
        id: "i_Iran",
        spritePath: spritePath.countriesSprite,
    },
    Iraq: {
        id: "i_Iraq",
        spritePath: spritePath.countriesSprite,
    },
    Ireland: {
        id: "i_Ireland",
        spritePath: spritePath.countriesSprite,
    },
    Israel: {
        id: "i_Israel",
        spritePath: spritePath.countriesSprite,
    },
    Italy: {
        id: "i_Italy",
        spritePath: spritePath.countriesSprite,
    },
    Jamaica: {
        id: "i_Jamaica",
        spritePath: spritePath.countriesSprite,
    },
    Japan: {
        id: "i_Japan",
        spritePath: spritePath.countriesSprite,
    },
    Jordan: {
        id: "i_Jordan",
        spritePath: spritePath.countriesSprite,
    },
    Kazakhstan: {
        id: "i_Kazakhstan",
        spritePath: spritePath.countriesSprite,
    },
    Kenya: {
        id: "i_Kenya",
        spritePath: spritePath.countriesSprite,
    },
    Kiribati: {
        id: "i_Kiribati",
        spritePath: spritePath.countriesSprite,
    },
    Kosovo: {
        id: "i_Kosovo",
        spritePath: spritePath.countriesSprite,
    },
    Kuwait: {
        id: "i_Kuwait",
        spritePath: spritePath.countriesSprite,
    },
    Kyrgyzstan: {
        id: "i_Kyrgyzstan",
        spritePath: spritePath.countriesSprite,
    },
    Laos: {
        id: "i_Laos",
        spritePath: spritePath.countriesSprite,
    },
    Latvia: {
        id: "i_Latvia",
        spritePath: spritePath.countriesSprite,
    },
    Lebanon: {
        id: "i_Lebanon",
        spritePath: spritePath.countriesSprite,
    },
    Lesotho: {
        id: "i_Lesotho",
        spritePath: spritePath.countriesSprite,
    },
    Liberia: {
        id: "i_Liberia",
        spritePath: spritePath.countriesSprite,
    },
    Libya: {
        id: "i_Libya",
        spritePath: spritePath.countriesSprite,
    },
    Liechtenstein: {
        id: "i_Liechtenstein",
        spritePath: spritePath.countriesSprite,
    },
    Lithuania: {
        id: "i_Lithuania",
        spritePath: spritePath.countriesSprite,
    },
    Luxembourg: {
        id: "i_Luxembourg",
        spritePath: spritePath.countriesSprite,
    },
    Macau: {
        id: "i_Macau",
        spritePath: spritePath.countriesSprite,
    },
    Macedonia: {
        id: "i_Macedonia",
        spritePath: spritePath.countriesSprite,
    },
    Madagascar: {
        id: "i_Madagascar",
        spritePath: spritePath.countriesSprite,
    },
    Malawi: {
        id: "i_Malawi",
        spritePath: spritePath.countriesSprite,
    },
    Malaysia: {
        id: "i_Malaysia",
        spritePath: spritePath.countriesSprite,
    },
    Maldives: {
        id: "i_Maldives",
        spritePath: spritePath.countriesSprite,
    },
    Mali: {
        id: "i_Mali",
        spritePath: spritePath.countriesSprite,
    },
    Malta: {
        id: "i_Malta",
        spritePath: spritePath.countriesSprite,
    },
    MarshallIslands: {
        id: "i_Marshall_Islands",
        spritePath: spritePath.countriesSprite,
    },
    Martinique: {
        id: "i_Martinique",
        spritePath: spritePath.countriesSprite,
    },
    Mauritania: {
        id: "i_Mauritania",
        spritePath: spritePath.countriesSprite,
    },
    Mauritius: {
        id: "i_Mauritius",
        spritePath: spritePath.countriesSprite,
    },
    Mayotte: {
        id: "i_Mayotte",
        spritePath: spritePath.countriesSprite,
    },
    Mexico: {
        id: "i_Mexico",
        spritePath: spritePath.countriesSprite,
    },
    Micronesia: {
        id: "i_Micronesia",
        spritePath: spritePath.countriesSprite,
    },
    Moldova: {
        id: "i_Moldova",
        spritePath: spritePath.countriesSprite,
    },
    Monaco: {
        id: "i_Monaco",
        spritePath: spritePath.countriesSprite,
    },
    Mongolia: {
        id: "i_Mongolia",
        spritePath: spritePath.countriesSprite,
    },
    Montenegro: {
        id: "i_Montenegro",
        spritePath: spritePath.countriesSprite,
    },
    Morocco: {
        id: "i_Morocco",
        spritePath: spritePath.countriesSprite,
    },
    Mozambique: {
        id: "i_Mozambique",
        spritePath: spritePath.countriesSprite,
    },
    Myanmar: {
        id: "i_Myanmar",
        spritePath: spritePath.countriesSprite,
    },
    Namibia: {
        id: "i_Namibia",
        spritePath: spritePath.countriesSprite,
    },
    Nauru: {
        id: "i_Nauru",
        spritePath: spritePath.countriesSprite,
    },
    Nepal: {
        id: "i_Nepal",
        spritePath: spritePath.countriesSprite,
    },
    Netherlands: {
        id: "i_Netherlands",
        spritePath: spritePath.countriesSprite,
    },
    NewCaledonia: {
        id: "i_New_Caledonia",
        spritePath: spritePath.countriesSprite,
    },
    NewZealand: {
        id: "i_New_Zealand",
        spritePath: spritePath.countriesSprite,
    },
    Nicaragua: {
        id: "i_Nicaragua",
        spritePath: spritePath.countriesSprite,
    },
    Niger: {
        id: "i_Niger",
        spritePath: spritePath.countriesSprite,
    },
    Nigeria: {
        id: "i_Nigeria",
        spritePath: spritePath.countriesSprite,
    },
    NorthKorea: {
        id: "i_North_Korea",
        spritePath: spritePath.countriesSprite,
    },
    Norway: {
        id: "i_Norway",
        spritePath: spritePath.countriesSprite,
    },
    Oman: {
        id: "i_Oman",
        spritePath: spritePath.countriesSprite,
    },
    Pakistan: {
        id: "i_Pakistan",
        spritePath: spritePath.countriesSprite,
    },
    Palau: {
        id: "i_Palau",
        spritePath: spritePath.countriesSprite,
    },
    Palestine: {
        id: "i_Palestine",
        spritePath: spritePath.countriesSprite,
    },
    Panama: {
        id: "i_Panama",
        spritePath: spritePath.countriesSprite,
    },
    PapuaNewGuinea: {
        id: "i_Papua_New_Guinea",
        spritePath: spritePath.countriesSprite,
    },
    Paraguay: {
        id: "i_Paraguay",
        spritePath: spritePath.countriesSprite,
    },
    Peru: {
        id: "i_Peru",
        spritePath: spritePath.countriesSprite,
    },
    Philippines: {
        id: "i_Philippines",
        spritePath: spritePath.countriesSprite,
    },
    Poland: {
        id: "i_Poland",
        spritePath: spritePath.countriesSprite,
    },
    Portugal: {
        id: "i_Portugal",
        spritePath: spritePath.countriesSprite,
    },
    Puerto_Rico: {
        id: "i_Puerto_Rico",
        spritePath: spritePath.countriesSprite,
    },
    Qatar: {
        id: "i_Qatar",
        spritePath: spritePath.countriesSprite,
    },
    Réunion: {
        id: "i_Réunion",
        spritePath: spritePath.countriesSprite,
    },
    Romania: {
        id: "i_Romania",
        spritePath: spritePath.countriesSprite,
    },
    Russia: {
        id: "i_Russia",
        spritePath: spritePath.countriesSprite,
    },
    Rwanda: {
        id: "i_Rwanda",
        spritePath: spritePath.countriesSprite,
    },
    SaintKittsAndNevis: {
        id: "i_Saint_Kitts_and_Nevis",
        spritePath: spritePath.countriesSprite,
    },
    SaintLucia: {
        id: "i_Saint_Lucia",
        spritePath: spritePath.countriesSprite,
    },
    SaintVincentAndTheGrenadines: {
        id: "i_Saint_Vincent_and_the_Grenadines",
        spritePath: spritePath.countriesSprite,
    },
    Samoa: {
        id: "i_Samoa",
        spritePath: spritePath.countriesSprite,
    },
    SanMarino: {
        id: "i_San_Marino",
        spritePath: spritePath.countriesSprite,
    },
    SãoToméAndPríncipe: {
        id: "i_São_Tomé_and_Príncipe",
        spritePath: spritePath.countriesSprite,
    },
    SaudiArabia: {
        id: "i_Saudi_Arabia",
        spritePath: spritePath.countriesSprite,
    },
    Senegal: {
        id: "i_Senegal",
        spritePath: spritePath.countriesSprite,
    },
    Serbia: {
        id: "i_Serbia",
        spritePath: spritePath.countriesSprite,
    },
    Seychelles: {
        id: "i_Seychelles",
        spritePath: spritePath.countriesSprite,
    },
    SierraLeone: {
        id: "i_Sierra_Leone",
        spritePath: spritePath.countriesSprite,
    },
    Singapore: {
        id: "i_Singapore",
        spritePath: spritePath.countriesSprite,
    },
    Slovakia: {
        id: "i_Slovakia",
        spritePath: spritePath.countriesSprite,
    },
    Slovenia: {
        id: "i_Slovenia",
        spritePath: spritePath.countriesSprite,
    },
    SolomonIslands: {
        id: "i_Solomon_Islands",
        spritePath: spritePath.countriesSprite,
    },
    Somalia: {
        id: "i_Somalia",
        spritePath: spritePath.countriesSprite,
    },
    SouthAfrica: {
        id: "i_South_Africa",
        spritePath: spritePath.countriesSprite,
    },
    SouthKorea: {
        id: "i_South_Korea",
        spritePath: spritePath.countriesSprite,
    },
    SouthSudan: {
        id: "i_South_Sudan",
        spritePath: spritePath.countriesSprite,
    },
    Spain: {
        id: "i_Spain",
        spritePath: spritePath.countriesSprite,
    },
    SriLanka: {
        id: "i_Sri_Lanka",
        spritePath: spritePath.countriesSprite,
    },
    Sudan: {
        id: "i_Sudan",
        spritePath: spritePath.countriesSprite,
    },
    Suriname: {
        id: "i_Suriname",
        spritePath: spritePath.countriesSprite,
    },
    Swaziland: {
        id: "i_Swaziland",
        spritePath: spritePath.countriesSprite,
    },
    Sweden: {
        id: "i_Sweden",
        spritePath: spritePath.countriesSprite,
    },
    Switzerland: {
        id: "i_Switzerland",
        spritePath: spritePath.countriesSprite,
    },
    Syria: {
        id: "i_Syria",
        spritePath: spritePath.countriesSprite,
    },
    Taiwan: {
        id: "i_Taiwan",
        spritePath: spritePath.countriesSprite,
    },
    Tajikistan: {
        id: "i_Tajikistan",
        spritePath: spritePath.countriesSprite,
    },
    Tanzania: {
        id: "i_Tanzania",
        spritePath: spritePath.countriesSprite,
    },
    Thailand: {
        id: "i_Thailand",
        spritePath: spritePath.countriesSprite,
    },
    TimorLeste: {
        id: "i_Timor-Leste",
        spritePath: spritePath.countriesSprite,
    },
    Togo: {
        id: "i_Togo",
        spritePath: spritePath.countriesSprite,
    },
    Tonga: {
        id: "i_Tonga",
        spritePath: spritePath.countriesSprite,
    },
    TrinidadAndTobago: {
        id: "i_Trinidad_and_Tobago",
        spritePath: spritePath.countriesSprite,
    },
    Tunisia: {
        id: "i_Tunisia",
        spritePath: spritePath.countriesSprite,
    },
    Turkey: {
        id: "i_Turkey",
        spritePath: spritePath.countriesSprite,
    },
    Turkmenistan: {
        id: "i_Turkmenistan",
        spritePath: spritePath.countriesSprite,
    },
    Tuvalu: {
        id: "i_Tuvalu",
        spritePath: spritePath.countriesSprite,
    },
    Uganda: {
        id: "i_Uganda",
        spritePath: spritePath.countriesSprite,
    },
    Ukraine: {
        id: "i_Ukraine",
        spritePath: spritePath.countriesSprite,
    },
    UnitedArabEmirates: {
        id: "i_United_Arab_Emirates",
        spritePath: spritePath.countriesSprite,
    },
    UnitedKingdom: {
        id: "i_United_Kingdom",
        spritePath: spritePath.countriesSprite,
    },
    UnitedStates: {
        id: "i_United_States",
        spritePath: spritePath.countriesSprite,
    },
    Uruguay: {
        id: "i_Uruguay",
        spritePath: spritePath.countriesSprite,
    },
    Uzbekistan: {
        id: "i_Uzbekistan",
        spritePath: spritePath.countriesSprite,
    },
    Vanuatu: {
        id: "i_Vanuatu",
        spritePath: spritePath.countriesSprite,
    },
    VaticanCity: {
        id: "i_Vatican_City",
        spritePath: spritePath.countriesSprite,
    },
    Venezuela: {
        id: "i_Venezuela",
        spritePath: spritePath.countriesSprite,
    },
    Vietnam: {
        id: "i_Vietnam",
        spritePath: spritePath.countriesSprite,
    },
    Yemen: {
        id: "i_Yemen",
        spritePath: spritePath.countriesSprite,
    },
    Zambia: {
        id: "i_Zambia",
        spritePath: spritePath.countriesSprite,
    },
    Zimbabwe: {
        id: "i_Zimbabwe",
        spritePath: spritePath.countriesSprite,
    },
    BanxeLogo: {
        id: "i_banxeLogo",
        spritePath: spritePath.svgSprite,
    },
    caretLeft: {
        id:"i_caretLeft",
        spritePath: spritePath.svgSprite,
    },
    circleLoader: {
        id:'i_circle_loader',
        spritePath: spritePath.svgSprite,
    },
    x: {
        id:"i_x_close",
        spritePath: spritePath.svgSprite,
    },
    user: {
        id:"i_user",
        spritePath: spritePath.svgSprite,
    },
    briefcase: {
        id:"i_briefcase",
        spritePath: spritePath.svgSprite,
    },
}
